/**
 * Created by staffanrantzow on 14/06/16.
 */

import axios from 'axios';
import SalaryEntity from './salary-entity';
import { APIResult } from '../http';
import Service from '../service/service';
import { SalaryTypeConstants } from 'frilans-finans';
import InvoiceDateEntity from '../invoices/invoice-date-entity';
import PendingRequestEntity from '../entities/pending-request-entity';

class SalaryService extends Service {

  /**
   *
   * @param data the salaries
   * @param included included data for each salary (include=invoice,invoicesdates)
   * @returns {Array}
   */
  hydrateCollection (data, included) {
    var salaries = [];

    for (let i = 0; i < data.length; i++) {
      salaries.push(this.hydrate(data[i], included));
    }

    return salaries;
  }

  hydrate (salary, included = []) {
    let attr = salary.attributes;
    let invoiceDates = [];
    let invoice = [];
    let taxAgencySalary = null;
    let companyName = '';

    // Loop through the included data and store it correctly
    for (let inc of included) {
      const salaryInvoiceId = parseInt(salary.attributes.invoice_id);

      if (inc.type === 'invoices' && parseInt(inc.id) === salaryInvoiceId) {
        invoice.push(inc);
        companyName = inc.attributes.company_name;
      }
      if (inc.type === 'invoice-dates' &&
      parseInt(inc.attributes.invoice_id) === salaryInvoiceId) {
        invoiceDates.push(this.hydrateInvoiceDates(inc));
      }
      if (inc.type === 'tax-agency-salary' &&
      parseInt(inc.attributes.invoice_id) === (salaryInvoiceId+1) &&
      parseInt(inc.attributes.type_id) === salary.typeId) {
        taxAgencySalary = inc;
      }
    }

    // Sort invoice dates
    invoiceDates.sort((a, b) => a.date - b.date);

    return new SalaryEntity(
      salary.id,
      attr.allowance,
      attr.category_id,
      attr.type_id,
      attr.created_at,
      attr.gross_amount,
      attr.gross_old,
      attr.invoice_id,
      attr.net_amount,
      attr.paid_at,
      attr.payment_status,
      attr.planned_payment_at,
      attr.resent_status,
      attr.tax_amount,
      attr.taxkey_id,
      attr.to_pay,
      attr.travel,
      attr.user_id,
      companyName,
      attr.specification_pdf_url,
      invoice,
      invoiceDates,
      taxAgencySalary,
    );
  }

  hydrateInvoiceDates (data) {
    data = data.attributes;
    return new InvoiceDateEntity(
      data.date,
      data.hours,
      data.invoice_id
    );
  }

  getFilterCategory () {
    return 'filter[category_id][<]=5';
  }

  getFilterType () {
    const types = [
      SalaryTypeConstants.REGULAR_TYPE,
      SalaryTypeConstants.VACATION_TYPE,
      SalaryTypeConstants.EXPENSE_TYPE,
      SalaryTypeConstants.EXPENSE_TRAVEL_TYPE,
      SalaryTypeConstants.SICK_PAYMENT_TYPE,
      SalaryTypeConstants.KRONOFOGDEN_PAYMENT_TYPE,
      SalaryTypeConstants.TRAVEL_ALLOWANCE_PAYMENT_TYPE
    ];
    return 'filter[type_id][in]=' + types.join(',');
  }

  getSums (userId, dateFilter) {
    let filter = `${this.getFilterDate(dateFilter, 'paid_at')}&${this.getFilterCategory()}&${this.getFilterType()}`;
    let pendingRequest = new PendingRequestEntity();
    pendingRequest.promise = axios.get(`backend://users/${userId}/salary-sums${filter}`, {
      cancelToken: new axios.CancelToken(function executor (c) {
        pendingRequest.cancel = c;
      })
    })
      .then(
        (response) => {
          return response.data.data.attributes;
        }
      );
    return pendingRequest;
  }

  createSalarySpecification (salaryIds) {
    let pendingRequest = new PendingRequestEntity();
    pendingRequest.promise = axios.post('backend://salary-specifications', {
      data: {
        attributes: {
          salary_ids: salaryIds
        }
      }
    })
      .then(
        (response) => {
          return response.data.data.attributes;
        }
      );
    return pendingRequest;
  }

  get (userId, page, size, dateFilter, sort) {
    let filter = `${this.getFilterDate(dateFilter, 'paid_at')}&${this.getFilterCategory()}&${this.getFilterType()}`;
    let pendingRequest = new PendingRequestEntity();
    let url = 'backend://users/' + userId + '/salaries' +
      filter + '&filter[not_tax_agency_salary]=1&include=invoice,invoice.invoicedates,taxagencysalary';

    pendingRequest.promise = axios.get(url, {
      params: {
        'page[number]': page || 1,
        'page[size]': size || 25,
        'sort': sort || ''
      },
      cancelToken: new axios.CancelToken(function executor (c) {
        pendingRequest.cancel = c;
      })
    })
      .then(
        (response) => {
          var salaries = this.hydrateCollection(response.data.data, response.data.included);
          return new APIResult(salaries, response.data.meta);
        }
      );
    return pendingRequest;
  }
}

export default new SalaryService();



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/salaries/salary-service.js
 **/